import FarmLotList from '../../views/FarmLot/FarmLotList';
import FarmLotEdit from '../../views/FarmLot/FarmLotEdit';
import FarmLotSearch from '../../views/FarmLot/components/FarmLotSearch';

export default [
    {
        path: '/lotes',
        name: 'lot.list',
        component: FarmLotList,
        meta: {
            pageTitle: 'Lotes/Piquetes',
            searchBar: FarmLotSearch,
            breadcrumb: [
                { label: 'Lotes/Piquetes' },
            ],
        },
    },
    {
        path: '/lotes/cadastro',
        name: 'lot.create',
        component: FarmLotEdit,
        meta: {
            pageTitle: 'Cadastro de Lote/Piquete',
            breadcrumb: [
                { label: 'Lotes/Piquetes', routeName: 'lot.list' },
                { label: 'Cadastro de Lote/Piquete' },
            ],
        },
    },
    {
        path: '/lotes/:id',
        name: 'lot.edit',
        component: FarmLotEdit,
        meta: {
            pageTitle: 'Edição de Lote/Piquete',
            breadcrumb: [
                { label: 'Lotes/Piquetes', routeName: 'lot.list' },
                { label: 'Edição de Lote/Piquete' },
            ],
        },
    },
];
